<template>
  <basic-container id="container">

    <div class="section">
      <div class="title">用户信息</div>
      <div class="content">
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> UUID： </span>
            <span class="text"> {{ initData[`${type}Uuid`] }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> 用户昵称： </span>
            <span class="text"> {{ initData.username }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="_col"> <span class="name"> 用户手机号： </span>
            <span class="text"> {{ initData.mobile }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> 会员类型: </span>
            <span class="text"> {{ userMemberType }} </span>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="section">
      <div class="title">设备信息</div>
      <div class="content">
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> HID： </span>
            <span class="text"> {{ initData[`${type}HardwareId`]}} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> UID： </span>
            <span class="text"> {{ initData[`${type}Uid`] }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> 渠道来源： </span>
            <span class="text"> {{ initData[`${type}Appid`] }} {{ getChannelNameDisplay(type) }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> 设备厂商： </span>
            <span class="text"> {{ initData[`${type}DeviceBrand`] }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> 设备型号：</span>
            <span class="text"> {{ initData[`${type}DeviceModel`] }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> App 版本号： </span>
            <span class="text"> {{ initData[`${type}AppVersion`] }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="_col"> <span class="name"> SDK 版本号： </span>
            <span class="text"> {{ initData[`${type}SdkVersion`] }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> IP： </span>
            <span class="text">  {{ initData[`${type}Ip`] || initData[`${type}DeviceIp`] }}  （ {{ initData[`${type}IpAddress`] || initData[`${type}DeviceIpAddress`] || '-' }}   ）  </span>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 推送特有信息 -->
    <div class="section" v-if="initData.castType === 'push'">
      <div class="title">推送信息</div>
      <div class="content">
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name">媒资类型：</span>
            <span class="text">{{ getMimeTypeName(initData.mimeType) }}</span>
          </el-col>
          <el-col :span="24" class="_col">
            <span class="name">URL：</span>
            <span class="text">{{ initData.url || '-' }}</span>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 投屏事件流 -->
    <div class="section">
      <div class="title">
        <div>投屏事件流</div>
      </div>
      <div class="content">
        <EventFlow ref="EventFlow" 
                   :castType="initData.castType || 'mirror'"
                   :uri="$route.query.uri"
                   :pdate="$route.query.pdate"
                   :serviceType="initData.serviceType">
        </EventFlow>
      </div>
    </div>

    <div class="section" style="margin-top: 63px;">
      <div class="title">
        <div>{{ initData.castType === 'push' ? '' : '实时质量' }} 
          <span v-if="initData.castType !== 'push'" class="el-icon-refresh-left _btn" @click="renovateFlow"></span>
          <el-button v-if="initData.castType === 'push'" type="primary" size="small" @click="handleLogReport">日志上报</el-button>
        </div>
      </div>
      <!-- 推送场景显示日志上报按钮，镜像场景显示实时质量组件 -->
      <RealTimeQuality v-if="initData.castType !== 'push'" ref="RealTimeQuality" :uid="initData[`${type}Uid`]" :appid="initData[`${type}Appid`]"></RealTimeQuality>
    </div>

    <!-- 日志上报弹框 -->
    <el-dialog
      title="日志上报"
      :visible.sync="logDialogVisible"
      width="500px"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :append-to-body="true"
      :modal-append-to-body="true"
      :lock-scroll="true">
      <div>
        <el-form label-width="100px">
          <el-form-item label="问题描述：">
            <el-input
              v-model="faultDescription"
              type="textarea"
              :rows="4"
              placeholder="请输入问题描述"
              maxlength="500"
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="logLoading" @click="confirmSendLog">上报</el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>
<script>
import RealTimeQuality from "./components/datailRealTimeQuality"
import EventFlow from "./components/datailEventFlow"  
import { getUserMemberType } from '@/api/memberNew/memberType'
import { reportLogToLeboCloud } from "@/api/rabbit/detail";

export default {
  components: { RealTimeQuality, EventFlow },
  data() {
    return {
      initData: {},
      type:'source',
      userMemberType: '', // 用户会员类型
      logDialogVisible: false, // 日志上报弹框可见性
      faultDescription: '', // 问题描述
      logLoading: false // 日志上报按钮加载状态
    }
  },
  created() {
    this.init()
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val === '/imageManagement/mirrorUserDetails') {
          this.init()
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    renovateFlow() {
      this.$refs['RealTimeQuality'].init()
    },
    async init() {
      try {
        // 重置数据状态
        this.userMemberType = ''
        this.logDialogVisible = false
        this.faultDescription = ''
        this.logLoading = false
        
        this.initData = JSON.parse(this.$route.query.data)
        console.log('this.initData',this.initData)
        this.type = this.initData.isOut ? 'source' : 'sink'
        
        // 查询会员类型
        await this.getUserMemberType()
        
        //如果为空显 '-'
        // for (let key in this.initData) {
        //   if (this.initData[key] == "") {
        //     this.initData[key] = "-"
        //   }
        // }
      } catch (err) {
        console.log(err)
      }
    },
    
    // 根据UUID查询会员类型
    async getUserMemberType() {
      try {
        const uuid = this.initData[`${this.type}Uuid`] || this.initData.uuid
        // 开始时间优先从路由query读取，其次从initData.createTime读取
        const startTime = this.$route.query.createTime || this.initData.createTime
        
        // 如果没有UUID，直接设置会员类型为空
        if (!uuid) {
          this.userMemberType = ''
          return
        }
        
        const res = await getUserMemberType(uuid, startTime)
        if (res.data && res.data.data) {
          this.userMemberType = res.data.data.memberTypeName || '查询异常'
        } else {
          this.userMemberType = ''
        }
      } catch (err) {
        console.log('查询会员类型失败:', err)
        this.userMemberType = '查询异常'
      }
    },
    
    // 获取媒体类型名称
    getMediaTypeName(mediaType) {
      const mediaTypeMap = {
        'video': '视频',
        'music': '音乐',
        'image': '图片'
      };
      return mediaTypeMap[mediaType] || '-';
    },
    
    // 获取媒资类型名称
    getMimeTypeName(mimeType) {
      const mimeTypeMap = {
        '101': '音频',
        '102': '视频', 
        '103': '图片',
        '104': '幻灯片',
        '105': '其他'
      };
      return mimeTypeMap[mimeType] || mimeType || '-';
    },
    
    // 获取渠道名称显示格式
    getChannelNameDisplay(type) {
      if (type === 'source') {
        // 发端显示来源渠道名称
        return this.initData.sourceAppName ? `(${this.initData.sourceAppName})` : '';
      } else {
        // 收端显示收端渠道名称
        return this.initData.sinkAppName ? `(${this.initData.sinkAppName})` : '';
      }
    },
    
    // 处理推送场景的日志上报
    async handleLogReport() {
      console.log('推送场景 - 点击了日志上报按钮');
      this.logDialogVisible = true;
      this.faultDescription = ''; // 清空问题描述
    },

    // 确认发送日志
    async confirmSendLog() {
      if (!this.faultDescription.trim()) {
        this.$message.warning('请输入问题描述')
        return
      }

      this.logLoading = true
      try {
        const params = {
          uid: this.initData[`${this.type}Uid`] || this.initData.uid,
          description: this.faultDescription.trim(),
          appId: this.initData[`${this.type}Appid`] || this.initData.appid
        }

        let res = await reportLogToLeboCloud(params)
        console.log('日志上报响应:', res)

        if (res.data && res.data.code === 200) {
          this.$message.success('已通知客户端上报日志')
          this.logDialogVisible = false
        } else {
          this.$message.error((res.data && res.data.message) || '通知客户端上报日志失败')
        }
      } catch (error) {
        console.error('日志上报失败:', error)
        this.$message.error('日志上报失败，请稍后重试')
      } finally {
        this.logLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
#container {
  padding: 0px 34px;
  background-color: #fff;
  margin: 8px 0px 100px 29px;
  width: calc(100% - 40px);

}

.section {
  margin-bottom: 45px;
  text-align: left;
  font-family: SourceHanSansSC-regular;

  .title {
    color: #101010 100%;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    ._btn{
      color: #1372e8;
      cursor: pointer;
      font-size: 14px;
      font-weight: normal;
      padding: 5px 10px;
      border-radius: 5px;
   
    }
  }

  .content {
    margin-top: 21px;
    background-color: #F9F7F7;
    padding: 2px 30px 27px;
    color: #101010;
    font-size: 14px;

    ._col {
      display: flex;
      margin-top: 22px;

      .name {
        width: 160px;
      }
      
      .text {
        word-break: break-all;
        white-space: pre-wrap;
        max-width: 100%;
        flex: 1;
      }
    }
  }

  // 日志上报部分样式
  .log-report-section {
    margin-top: 21px;
    background-color: #F9F7F7;
    padding: 20px 30px;
    
    .Escalation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .time {
        color: #666;
        font-size: 14px;
      }
      
      .el-button {
        background-color: #409EFF;
        border-color: #409EFF;
        color: #fff;
        
        &:hover {
          background-color: #66b1ff;
          border-color: #66b1ff;
        }
      }
    }
  }
}

/deep/ .el-col {
  margin-bottom: -5px;
}

// 日志上报弹框样式
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
    
    .el-form-item__label {
      font-weight: 500;
      color: #333;
    }
    
    .el-textarea {
      .el-textarea__inner {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 1.5;
        resize: vertical;
        
        &:focus {
          border-color: #409eff;
          outline: none;
        }
        
        &::placeholder {
          color: #c0c4cc;
        }
      }
    }
  }
  
  .dialog-footer {
    text-align: right;
    padding-top: 10px;
    
    .el-button {
      margin-left: 10px;
    }
  }
}
</style>